export default __webpack_public_path__ + "static/media/middle.627b7e45.jpg";